import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getSubscriptionInvoices } from 'queries';
import { parseErrors, Toast } from 'helpers';
import { JsonDataItem } from 'types';

const PER_PAGE = 10;

export const useSubscriptionInvoices = (subscriptionId?: number, enabled?: boolean) => {
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery(['subscription-invoices', subscriptionId, page], getSubscriptionInvoices, {
    enabled: !!enabled && !!subscriptionId,
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  const paginationMetadata = {
    total: data?.total ?? 0,
    current_page: data?.current_page ?? page,
    pageSize: PER_PAGE,
    onChange: (nextPage: number) => setPage(nextPage),
  };

  return {
    invoices: data?.data,
    paginationMetadata,
    setPage,
    isLoading,
  };
};
